import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class NAOUpdateFeedbackTypeService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/NAOUpdateFeedbackTypes`);
    }
}